import PropTypes from "prop-types"

export const Paragraph = PropTypes.shape({
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
})
